import { rowStructure } from '../../redux/features/burst/types';

const getNumberOfInactiveRows = (rows: rowStructure[]): number => {
  return rows.filter((row) => !row.active).length;
};

export default getNumberOfInactiveRows;
